module.exports = __webpack_public_path__ + "img/01_no.7c85204a.svg";